/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
import React from 'react'
import PropTypes from 'prop-types'

import LinearGradient from 'react-native-linear-gradient'

import { View, ImageBackground, useWindowDimensions } from 'react-native'

import { Icon, VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components'

import VFTextWithLoader from '../VFTextWithLoader'

import ContentLoader, { Rect } from 'react-content-loader/native'

import { Images } from '../../Themes'

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import styles from './OfferCard.Styles'

const OfferCard = ({
  title,
  image,
  description,
  planDetails,
  buttonTitle,
  onPress,
  style,
  withButton,
  recommandationLoading,
  ...props
}) => {
  const { width } = useWindowDimensions()

  const theme = useTheme()
  return (
    <View
      style={[
        { width: '100%', height: 'auto', borderRadius: 10, flex: 1 },
        style
      ]}
    >
      <ImageBackground
        source={image}
        resizeMode="cover"
        style={styles.image}
        imageStyle={{ borderRadius: 10 }}
      >
        <LinearGradient
          colors={['rgba(130, 0, 0, 0.8)', 'rgba(230, 0, 0, 0.8)']}
          style={{ borderRadius: 10, overflow: 'hidden' }}
          start={{ x: 0, y: 1 }}
          end={{ x: 1, y: 0 }}
        >
          {recommandationLoading && <ContentLoader
            width={width}
            height={80}
            backgroundColor={theme.colors.shimmerCenterColor}
            foregroundColor={theme.colors.shimmerEdgesColor}
            viewBox={`0 0 ${width} ${80}`}
          >
            <Rect x="10" y="10" rx="5" ry="5" width={250} height={20} />
            <Rect x="10" y="40" rx="5" ry="5" width={300} height={20} />
            {withButton && (<Rect x="100" y="30" rx="5" ry="5" width={100} height={18} />)}
          </ContentLoader>
          }
          {!recommandationLoading &&
            <View style={{ padding: 16, width: '100%' }}>
              <VFText
                i18nKey={title}
                style={styles.cardTitle}
                {...props}
              />
              <VFText
                i18nKey={description}
                style={styles.cardDescription}
                {...props}
              />
              {planDetails && (
                <>
                  <View style={styles.row}>
                    <Icon
                      source={Images.smsTextWhite}
                      size={24}
                      style={{ marginRight: 20 }}
                    />
                    <VFText
                      i18nKey={planDetails.sms}
                      style={styles.cardDescription}
                    />
                  </View>
                  <View style={styles.row}>
                    <Icon
                      source={Images.callLogWhite}
                      size={24}
                      style={{ marginRight: 20 }}
                    />
                    <VFText
                      i18nKey={planDetails.min}
                      style={styles.cardDescription}
                    />
                  </View>
                  <View style={styles.row}>
                    <Icon
                      source={Images.dataSharingWhite}
                      size={24}
                      style={{ marginRight: 20 }}
                    />
                    <VFText
                      i18nKey={planDetails.data}
                      style={styles.cardDescription}
                    />
                  </View>
                </>
              )}

              {/* If you don't add buttonTitle it means you don't want to have button included */}
              {withButton && (
                <VFButton
                  title={`${buttonTitle}`}
                  type="primaryWhite"
                  style={{ marginTop: 16 }}
                  onPress={onPress}
                />
              )}
            </View>
          }
        </LinearGradient>
      </ImageBackground>
    </View>
  )
}

OfferCard.defaultProps = {}

OfferCard.propTypes = {
  title: PropTypes.string,
  placeHolders: PropTypes.array,
  image: PropTypes.string,
  description: PropTypes.string,
  descriptionPlaceHolders: PropTypes.string,
  planDetails: PropTypes.object,
  buttonTitle: PropTypes.string,
  onPress: PropTypes.func,
  style: PropTypes.object
}

export default OfferCard
